import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";
import Table from "../../components/Table";

export default function InvestorStatement({ lang = {} }) {
  const [statement, setStatement] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchStatement();
  }, []);

  const fetchStatement = (sDate = "", eDate = "") => {
    const session = JSON.parse(sessionStorage.getItem("aman-investor") || "{}");
    const token = session.token;
    if (!token) return;

    let url = `${apiKey}/investor-panel/statement`;
    if (sDate && eDate) {
      url += `?startDate=${sDate}&endDate=${eDate}`;
    }

    axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setStatement(res.data.statement || []);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchStatement(startDate, endDate);
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    fetchStatement("", "");
  };

  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang["Date"] || "Date",
      accessorKey: "date",
      cell: (row) => (row.getValue() ? new Date(row.getValue()).toLocaleDateString() : "N/A"),
    },
    // {
    //   header: lang["Tx_ID"] || "Transaction ID",
    //   accessorKey: "id",
    //   cell: (row) => <span className="fw-bold text-primary">#{row.getValue()}</span>,
    // },
    {
      header: lang["Type"] || "Type",
      accessorKey: "type",
      cell: (row) => {
        const type = row.getValue() || row.row.original.transaction_type;
        const isDep = type === "deposit" || type === "investor_deposit";
        return (
          <span className={`badge ${isDep ? "bg-success" : "bg-warning text-dark"}`}>
            {isDep ? "Deposit" : "Withdrawal"}
          </span>
        );
      },
    },
    {
      header: lang["Branch"] || "Branch",
      accessorKey: "branch_name",
      cell: (row) => row.getValue() || "Main Branch",
    },
    {
      header: lang["Amount"] || "Amount (SAR)",
      accessorKey: "amount",
      cell: (row) => {
        const type = row.row.original.type || row.row.original.transaction_type;
        const isDep = type === "deposit" || type === "investor_deposit";
        return (
          <span className={`fw-bold ${isDep ? "text-success" : "text-danger"}`}>
            {isDep ? "+" : "-"} SAR {Number(row.getValue() || 0).toLocaleString()}
          </span>
        );
      },
    },
  ];

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Statement || "Investor Account Statement"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang.Home || "Home"}</li>
            <li className="breadcrumb-item active">{lang.Statement || "Account Statement"}</li>
          </ol>
        </nav>
      </div>

      {/* Date Filter Card */}
      <div className="card shadow-sm border-0 rounded-3 mb-4">
        <div className="card-body p-3">
          <form onSubmit={handleFilter} className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className="form-label small fw-bold text-secondary">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label small fw-bold text-secondary">End Date</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-4 d-flex gap-2">
              <button type="submit" className="btn btn-primary fw-bold flex-grow-1">
                <i className="fa fa-filter me-1"></i> Filter Statement
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary fw-bold"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Statement Table */}
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">
                  {lang.Detailed_Statement || "Detailed Financial Statement"}
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <Table
                    columns={columns}
                    data={statement}
                    lang={lang}
                    // exportOption={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
